"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewContext = exports.ImpressionData = exports.ViewContext_OrganicContextAssetType = exports.ViewContext_OrganicAssetType = exports.ViewContext_OperaActionBarType = exports.ViewContext_AttachmentTriggerType = exports.ViewContext_Position = void 0;
const ad_flag_data_1 = require("./ad_flag_data");
const cognac_metadata_1 = require("./cognac_metadata");
const ad_hiding_data_1 = require("./ad_hiding_data");
const three_v_impression_track_1 = require("./three_v_impression_track");
const app_install_impression_track_1 = require("./app_install_impression_track");
const longform_video_impression_track_1 = require("./longform_video_impression_track");
const remote_webpage_impression_track_1 = require("./remote_webpage_impression_track");
const local_webpage_impression_track_1 = require("./local_webpage_impression_track");
const story_impression_track_1 = require("./story_impression_track");
const lens_impression_track_1 = require("./lens_impression_track");
const filter_impression_track_1 = require("./filter_impression_track");
const deep_link_impression_track_1 = require("./deep_link_impression_track");
const subscribe_impression_track_1 = require("./subscribe_impression_track");
const ad_to_lens_impression_track_1 = require("./ad_to_lens_impression_track");
const collection_impression_track_1 = require("./collection_impression_track");
const unlockable_view_impression_track_1 = require("./unlockable_view_impression_track");
const ad_to_call_impression_track_1 = require("./ad_to_call_impression_track");
const ad_to_message_impression_track_1 = require("./ad_to_message_impression_track");
const showcase_impression_track_1 = require("./showcase_impression_track");
const ad_to_place_impression_track_1 = require("./ad_to_place_impression_track");
const lead_generation_impression_track_1 = require("./lead_generation_impression_track");
const pay_to_promote_impression_track_1 = require("./pay_to_promote_impression_track");
const reminder_impression_track_1 = require("./reminder_impression_track");
const survey_impression_track_1 = require("./survey_impression_track");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
var ViewContext_Position;
(function (ViewContext_Position) {
    ViewContext_Position[ViewContext_Position["UNKNOWN_POSITION"] = 0] = "UNKNOWN_POSITION";
    ViewContext_Position[ViewContext_Position["POST_ROLL"] = 1] = "POST_ROLL";
    ViewContext_Position[ViewContext_Position["MID_ROLL"] = 2] = "MID_ROLL";
    ViewContext_Position[ViewContext_Position["PRE_ROLL"] = 3] = "PRE_ROLL";
    ViewContext_Position[ViewContext_Position["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ViewContext_Position = exports.ViewContext_Position || (exports.ViewContext_Position = {}));
var ViewContext_AttachmentTriggerType;
(function (ViewContext_AttachmentTriggerType) {
    ViewContext_AttachmentTriggerType[ViewContext_AttachmentTriggerType["NONE"] = 0] = "NONE";
    ViewContext_AttachmentTriggerType[ViewContext_AttachmentTriggerType["SWIPE_UP"] = 1] = "SWIPE_UP";
    ViewContext_AttachmentTriggerType[ViewContext_AttachmentTriggerType["TAP"] = 2] = "TAP";
    ViewContext_AttachmentTriggerType[ViewContext_AttachmentTriggerType["SWIPE_LEFT"] = 3] = "SWIPE_LEFT";
    ViewContext_AttachmentTriggerType[ViewContext_AttachmentTriggerType["FOREGROUND"] = 4] = "FOREGROUND";
    ViewContext_AttachmentTriggerType[ViewContext_AttachmentTriggerType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ViewContext_AttachmentTriggerType = exports.ViewContext_AttachmentTriggerType || (exports.ViewContext_AttachmentTriggerType = {}));
var ViewContext_OperaActionBarType;
(function (ViewContext_OperaActionBarType) {
    /** OPAQUE - Used on tall device, action bar shows below main snap content */
    ViewContext_OperaActionBarType[ViewContext_OperaActionBarType["OPAQUE"] = 0] = "OPAQUE";
    /** TRANSLUCENT - Used on short device, action bar overlaps main snap content with a translucent background */
    ViewContext_OperaActionBarType[ViewContext_OperaActionBarType["TRANSLUCENT"] = 1] = "TRANSLUCENT";
    ViewContext_OperaActionBarType[ViewContext_OperaActionBarType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ViewContext_OperaActionBarType = exports.ViewContext_OperaActionBarType || (exports.ViewContext_OperaActionBarType = {}));
var ViewContext_OrganicAssetType;
(function (ViewContext_OrganicAssetType) {
    ViewContext_OrganicAssetType[ViewContext_OrganicAssetType["ORGANIC_ASSET_TYPE_UNKNOWN"] = 0] = "ORGANIC_ASSET_TYPE_UNKNOWN";
    ViewContext_OrganicAssetType[ViewContext_OrganicAssetType["ORGANIC_ASSET_TYPE_STORY"] = 1] = "ORGANIC_ASSET_TYPE_STORY";
    ViewContext_OrganicAssetType[ViewContext_OrganicAssetType["ORGANIC_ASSET_TYPE_GAME"] = 2] = "ORGANIC_ASSET_TYPE_GAME";
    ViewContext_OrganicAssetType[ViewContext_OrganicAssetType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ViewContext_OrganicAssetType = exports.ViewContext_OrganicAssetType || (exports.ViewContext_OrganicAssetType = {}));
var ViewContext_OrganicContextAssetType;
(function (ViewContext_OrganicContextAssetType) {
    ViewContext_OrganicContextAssetType[ViewContext_OrganicContextAssetType["ORGANIC_CONTENT_ASSET_TYPE_UNKNOWN"] = 0] = "ORGANIC_CONTENT_ASSET_TYPE_UNKNOWN";
    ViewContext_OrganicContextAssetType[ViewContext_OrganicContextAssetType["ORGANIC_CONTENT_ASSET_TYPE_STORY"] = 1] = "ORGANIC_CONTENT_ASSET_TYPE_STORY";
    ViewContext_OrganicContextAssetType[ViewContext_OrganicContextAssetType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ViewContext_OrganicContextAssetType = exports.ViewContext_OrganicContextAssetType || (exports.ViewContext_OrganicContextAssetType = {}));
function createBaseImpressionData() {
    return {
        adType: 0,
        typedTrackData: undefined,
        thirdPartyUrls: [],
        viewContext: undefined,
        adFlagData: undefined,
        screenWidth: undefined,
        screenHeight: undefined,
        creativeHeight: undefined,
        creativeWidth: undefined,
        isUnskippableAd: undefined,
        cognac: undefined,
        thirdPartyImpressionUrls: [],
        thirdPartyClickUrls: [],
        additionalFormatType: 0,
        skAdNetworkVersion: undefined,
        thirdPartyEngagedViewUrls: [],
        openProfilePage: undefined,
        adHidingData: undefined,
        skAdNetworkClickThroughVersion: undefined,
        skAdNetworkViewThroughVersion: undefined,
    };
}
exports.ImpressionData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.adType !== 0) {
            writer.uint32(8).int32(message.adType);
        }
        if (message.typedTrackData?.$case === "threeV") {
            three_v_impression_track_1.ThreeVImpressionTrack.encode(message.typedTrackData.threeV, writer.uint32(18).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "appInstall") {
            app_install_impression_track_1.AppInstallImpressionTrack.encode(message.typedTrackData.appInstall, writer.uint32(26).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "longformVideo") {
            longform_video_impression_track_1.LongformVideoImpressionTrack.encode(message.typedTrackData.longformVideo, writer.uint32(34).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "remoteWebpage") {
            remote_webpage_impression_track_1.RemoteWebpageImpressionTrack.encode(message.typedTrackData.remoteWebpage, writer.uint32(42).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "localWebpage") {
            local_webpage_impression_track_1.LocalWebpageImpressionTrack.encode(message.typedTrackData.localWebpage, writer.uint32(50).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "story") {
            story_impression_track_1.StoryImpressionTrack.encode(message.typedTrackData.story, writer.uint32(58).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "lensCarousel") {
            lens_impression_track_1.LensCarouselImpressionTrack.encode(message.typedTrackData.lensCarousel, writer.uint32(66).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "filterCarousel") {
            filter_impression_track_1.FilterCarouselImpressionTrack.encode(message.typedTrackData.filterCarousel, writer.uint32(74).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "deepLink") {
            deep_link_impression_track_1.DeepLinkImpressionTrack.encode(message.typedTrackData.deepLink, writer.uint32(82).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "filter") {
            filter_impression_track_1.FilterImpressionTrack.encode(message.typedTrackData.filter, writer.uint32(90).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "lens") {
            lens_impression_track_1.LensImpressionTrack.encode(message.typedTrackData.lens, writer.uint32(98).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "subscribe") {
            subscribe_impression_track_1.SubscribeImpressionTrack.encode(message.typedTrackData.subscribe, writer.uint32(106).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "adToLens") {
            ad_to_lens_impression_track_1.AdToLensImpressionTrack.encode(message.typedTrackData.adToLens, writer.uint32(114).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "collection") {
            collection_impression_track_1.CollectionImpressionTrack.encode(message.typedTrackData.collection, writer.uint32(186).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "unlockableView") {
            unlockable_view_impression_track_1.UnlockableViewImpressionTrack.encode(message.typedTrackData.unlockableView, writer.uint32(194).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "lensExplorer") {
            lens_impression_track_1.LensExplorerImpressionTrack.encode(message.typedTrackData.lensExplorer, writer.uint32(226).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "adToCall") {
            ad_to_call_impression_track_1.AdToCallImpressionTrack.encode(message.typedTrackData.adToCall, writer.uint32(234).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "adToMessage") {
            ad_to_message_impression_track_1.AdToMessageImpressionTrack.encode(message.typedTrackData.adToMessage, writer.uint32(242).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "showcase") {
            showcase_impression_track_1.ShowcaseImpressionTrack.encode(message.typedTrackData.showcase, writer.uint32(250).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "adToPlace") {
            ad_to_place_impression_track_1.AdToPlaceImpressionTrack.encode(message.typedTrackData.adToPlace, writer.uint32(258).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "leadGeneration") {
            lead_generation_impression_track_1.LeadGenerationImpressionTrack.encode(message.typedTrackData.leadGeneration, writer.uint32(282).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "payToPromote") {
            pay_to_promote_impression_track_1.PayToPromoteImpressionTrack.encode(message.typedTrackData.payToPromote, writer.uint32(314).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "reminder") {
            reminder_impression_track_1.ReminderTrack.encode(message.typedTrackData.reminder, writer.uint32(338).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "survey") {
            survey_impression_track_1.SurveyImpressionTrack.encode(message.typedTrackData.survey, writer.uint32(346).fork()).ldelim();
        }
        for (const v of message.thirdPartyUrls) {
            wrappers_1.StringValue.encode({ value: v }, writer.uint32(122).fork()).ldelim();
        }
        if (message.viewContext !== undefined) {
            exports.ViewContext.encode(message.viewContext, writer.uint32(130).fork()).ldelim();
        }
        if (message.adFlagData !== undefined) {
            ad_flag_data_1.AdFlagData.encode(message.adFlagData, writer.uint32(138).fork()).ldelim();
        }
        if (message.screenWidth !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.screenWidth }, writer.uint32(146).fork()).ldelim();
        }
        if (message.screenHeight !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.screenHeight }, writer.uint32(154).fork()).ldelim();
        }
        if (message.creativeHeight !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.creativeHeight }, writer.uint32(162).fork()).ldelim();
        }
        if (message.creativeWidth !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.creativeWidth }, writer.uint32(170).fork()).ldelim();
        }
        if (message.isUnskippableAd !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isUnskippableAd }, writer.uint32(178).fork()).ldelim();
        }
        if (message.cognac !== undefined) {
            cognac_metadata_1.CognacMetadata.encode(message.cognac, writer.uint32(202).fork()).ldelim();
        }
        for (const v of message.thirdPartyImpressionUrls) {
            wrappers_1.StringValue.encode({ value: v }, writer.uint32(210).fork()).ldelim();
        }
        for (const v of message.thirdPartyClickUrls) {
            wrappers_1.StringValue.encode({ value: v }, writer.uint32(218).fork()).ldelim();
        }
        if (message.additionalFormatType !== 0) {
            writer.uint32(264).int32(message.additionalFormatType);
        }
        if (message.skAdNetworkVersion !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.skAdNetworkVersion }, writer.uint32(274).fork()).ldelim();
        }
        for (const v of message.thirdPartyEngagedViewUrls) {
            wrappers_1.StringValue.encode({ value: v }, writer.uint32(290).fork()).ldelim();
        }
        if (message.openProfilePage !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.openProfilePage }, writer.uint32(298).fork()).ldelim();
        }
        if (message.adHidingData !== undefined) {
            ad_hiding_data_1.AdHidingData.encode(message.adHidingData, writer.uint32(306).fork()).ldelim();
        }
        if (message.skAdNetworkClickThroughVersion !== undefined) {
            wrappers_1.StringValue.encode({ value: message.skAdNetworkClickThroughVersion }, writer.uint32(322).fork()).ldelim();
        }
        if (message.skAdNetworkViewThroughVersion !== undefined) {
            wrappers_1.StringValue.encode({ value: message.skAdNetworkViewThroughVersion }, writer.uint32(330).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseImpressionData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.adType = reader.int32();
                    break;
                case 2:
                    message.typedTrackData = {
                        $case: "threeV",
                        threeV: three_v_impression_track_1.ThreeVImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 3:
                    message.typedTrackData = {
                        $case: "appInstall",
                        appInstall: app_install_impression_track_1.AppInstallImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 4:
                    message.typedTrackData = {
                        $case: "longformVideo",
                        longformVideo: longform_video_impression_track_1.LongformVideoImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 5:
                    message.typedTrackData = {
                        $case: "remoteWebpage",
                        remoteWebpage: remote_webpage_impression_track_1.RemoteWebpageImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 6:
                    message.typedTrackData = {
                        $case: "localWebpage",
                        localWebpage: local_webpage_impression_track_1.LocalWebpageImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 7:
                    message.typedTrackData = {
                        $case: "story",
                        story: story_impression_track_1.StoryImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 8:
                    message.typedTrackData = {
                        $case: "lensCarousel",
                        lensCarousel: lens_impression_track_1.LensCarouselImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 9:
                    message.typedTrackData = {
                        $case: "filterCarousel",
                        filterCarousel: filter_impression_track_1.FilterCarouselImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 10:
                    message.typedTrackData = {
                        $case: "deepLink",
                        deepLink: deep_link_impression_track_1.DeepLinkImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 11:
                    message.typedTrackData = {
                        $case: "filter",
                        filter: filter_impression_track_1.FilterImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 12:
                    message.typedTrackData = {
                        $case: "lens",
                        lens: lens_impression_track_1.LensImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 13:
                    message.typedTrackData = {
                        $case: "subscribe",
                        subscribe: subscribe_impression_track_1.SubscribeImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 14:
                    message.typedTrackData = {
                        $case: "adToLens",
                        adToLens: ad_to_lens_impression_track_1.AdToLensImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 23:
                    message.typedTrackData = {
                        $case: "collection",
                        collection: collection_impression_track_1.CollectionImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 24:
                    message.typedTrackData = {
                        $case: "unlockableView",
                        unlockableView: unlockable_view_impression_track_1.UnlockableViewImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 28:
                    message.typedTrackData = {
                        $case: "lensExplorer",
                        lensExplorer: lens_impression_track_1.LensExplorerImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 29:
                    message.typedTrackData = {
                        $case: "adToCall",
                        adToCall: ad_to_call_impression_track_1.AdToCallImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 30:
                    message.typedTrackData = {
                        $case: "adToMessage",
                        adToMessage: ad_to_message_impression_track_1.AdToMessageImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 31:
                    message.typedTrackData = {
                        $case: "showcase",
                        showcase: showcase_impression_track_1.ShowcaseImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 32:
                    message.typedTrackData = {
                        $case: "adToPlace",
                        adToPlace: ad_to_place_impression_track_1.AdToPlaceImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 35:
                    message.typedTrackData = {
                        $case: "leadGeneration",
                        leadGeneration: lead_generation_impression_track_1.LeadGenerationImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 39:
                    message.typedTrackData = {
                        $case: "payToPromote",
                        payToPromote: pay_to_promote_impression_track_1.PayToPromoteImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 42:
                    message.typedTrackData = {
                        $case: "reminder",
                        reminder: reminder_impression_track_1.ReminderTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 43:
                    message.typedTrackData = {
                        $case: "survey",
                        survey: survey_impression_track_1.SurveyImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 15:
                    message.thirdPartyUrls.push(wrappers_1.StringValue.decode(reader, reader.uint32()).value);
                    break;
                case 16:
                    message.viewContext = exports.ViewContext.decode(reader, reader.uint32());
                    break;
                case 17:
                    message.adFlagData = ad_flag_data_1.AdFlagData.decode(reader, reader.uint32());
                    break;
                case 18:
                    message.screenWidth = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 19:
                    message.screenHeight = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 20:
                    message.creativeHeight = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 21:
                    message.creativeWidth = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 22:
                    message.isUnskippableAd = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 25:
                    message.cognac = cognac_metadata_1.CognacMetadata.decode(reader, reader.uint32());
                    break;
                case 26:
                    message.thirdPartyImpressionUrls.push(wrappers_1.StringValue.decode(reader, reader.uint32()).value);
                    break;
                case 27:
                    message.thirdPartyClickUrls.push(wrappers_1.StringValue.decode(reader, reader.uint32()).value);
                    break;
                case 33:
                    message.additionalFormatType = reader.int32();
                    break;
                case 34:
                    message.skAdNetworkVersion = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 36:
                    message.thirdPartyEngagedViewUrls.push(wrappers_1.StringValue.decode(reader, reader.uint32()).value);
                    break;
                case 37:
                    message.openProfilePage = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 38:
                    message.adHidingData = ad_hiding_data_1.AdHidingData.decode(reader, reader.uint32());
                    break;
                case 40:
                    message.skAdNetworkClickThroughVersion = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 41:
                    message.skAdNetworkViewThroughVersion = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseImpressionData();
        message.adType = object.adType ?? 0;
        if (object.typedTrackData?.$case === "threeV" &&
            object.typedTrackData?.threeV !== undefined &&
            object.typedTrackData?.threeV !== null) {
            message.typedTrackData = {
                $case: "threeV",
                threeV: three_v_impression_track_1.ThreeVImpressionTrack.fromPartial(object.typedTrackData.threeV),
            };
        }
        if (object.typedTrackData?.$case === "appInstall" &&
            object.typedTrackData?.appInstall !== undefined &&
            object.typedTrackData?.appInstall !== null) {
            message.typedTrackData = {
                $case: "appInstall",
                appInstall: app_install_impression_track_1.AppInstallImpressionTrack.fromPartial(object.typedTrackData.appInstall),
            };
        }
        if (object.typedTrackData?.$case === "longformVideo" &&
            object.typedTrackData?.longformVideo !== undefined &&
            object.typedTrackData?.longformVideo !== null) {
            message.typedTrackData = {
                $case: "longformVideo",
                longformVideo: longform_video_impression_track_1.LongformVideoImpressionTrack.fromPartial(object.typedTrackData.longformVideo),
            };
        }
        if (object.typedTrackData?.$case === "remoteWebpage" &&
            object.typedTrackData?.remoteWebpage !== undefined &&
            object.typedTrackData?.remoteWebpage !== null) {
            message.typedTrackData = {
                $case: "remoteWebpage",
                remoteWebpage: remote_webpage_impression_track_1.RemoteWebpageImpressionTrack.fromPartial(object.typedTrackData.remoteWebpage),
            };
        }
        if (object.typedTrackData?.$case === "localWebpage" &&
            object.typedTrackData?.localWebpage !== undefined &&
            object.typedTrackData?.localWebpage !== null) {
            message.typedTrackData = {
                $case: "localWebpage",
                localWebpage: local_webpage_impression_track_1.LocalWebpageImpressionTrack.fromPartial(object.typedTrackData.localWebpage),
            };
        }
        if (object.typedTrackData?.$case === "story" &&
            object.typedTrackData?.story !== undefined &&
            object.typedTrackData?.story !== null) {
            message.typedTrackData = {
                $case: "story",
                story: story_impression_track_1.StoryImpressionTrack.fromPartial(object.typedTrackData.story),
            };
        }
        if (object.typedTrackData?.$case === "lensCarousel" &&
            object.typedTrackData?.lensCarousel !== undefined &&
            object.typedTrackData?.lensCarousel !== null) {
            message.typedTrackData = {
                $case: "lensCarousel",
                lensCarousel: lens_impression_track_1.LensCarouselImpressionTrack.fromPartial(object.typedTrackData.lensCarousel),
            };
        }
        if (object.typedTrackData?.$case === "filterCarousel" &&
            object.typedTrackData?.filterCarousel !== undefined &&
            object.typedTrackData?.filterCarousel !== null) {
            message.typedTrackData = {
                $case: "filterCarousel",
                filterCarousel: filter_impression_track_1.FilterCarouselImpressionTrack.fromPartial(object.typedTrackData.filterCarousel),
            };
        }
        if (object.typedTrackData?.$case === "deepLink" &&
            object.typedTrackData?.deepLink !== undefined &&
            object.typedTrackData?.deepLink !== null) {
            message.typedTrackData = {
                $case: "deepLink",
                deepLink: deep_link_impression_track_1.DeepLinkImpressionTrack.fromPartial(object.typedTrackData.deepLink),
            };
        }
        if (object.typedTrackData?.$case === "filter" &&
            object.typedTrackData?.filter !== undefined &&
            object.typedTrackData?.filter !== null) {
            message.typedTrackData = {
                $case: "filter",
                filter: filter_impression_track_1.FilterImpressionTrack.fromPartial(object.typedTrackData.filter),
            };
        }
        if (object.typedTrackData?.$case === "lens" &&
            object.typedTrackData?.lens !== undefined &&
            object.typedTrackData?.lens !== null) {
            message.typedTrackData = {
                $case: "lens",
                lens: lens_impression_track_1.LensImpressionTrack.fromPartial(object.typedTrackData.lens),
            };
        }
        if (object.typedTrackData?.$case === "subscribe" &&
            object.typedTrackData?.subscribe !== undefined &&
            object.typedTrackData?.subscribe !== null) {
            message.typedTrackData = {
                $case: "subscribe",
                subscribe: subscribe_impression_track_1.SubscribeImpressionTrack.fromPartial(object.typedTrackData.subscribe),
            };
        }
        if (object.typedTrackData?.$case === "adToLens" &&
            object.typedTrackData?.adToLens !== undefined &&
            object.typedTrackData?.adToLens !== null) {
            message.typedTrackData = {
                $case: "adToLens",
                adToLens: ad_to_lens_impression_track_1.AdToLensImpressionTrack.fromPartial(object.typedTrackData.adToLens),
            };
        }
        if (object.typedTrackData?.$case === "collection" &&
            object.typedTrackData?.collection !== undefined &&
            object.typedTrackData?.collection !== null) {
            message.typedTrackData = {
                $case: "collection",
                collection: collection_impression_track_1.CollectionImpressionTrack.fromPartial(object.typedTrackData.collection),
            };
        }
        if (object.typedTrackData?.$case === "unlockableView" &&
            object.typedTrackData?.unlockableView !== undefined &&
            object.typedTrackData?.unlockableView !== null) {
            message.typedTrackData = {
                $case: "unlockableView",
                unlockableView: unlockable_view_impression_track_1.UnlockableViewImpressionTrack.fromPartial(object.typedTrackData.unlockableView),
            };
        }
        if (object.typedTrackData?.$case === "lensExplorer" &&
            object.typedTrackData?.lensExplorer !== undefined &&
            object.typedTrackData?.lensExplorer !== null) {
            message.typedTrackData = {
                $case: "lensExplorer",
                lensExplorer: lens_impression_track_1.LensExplorerImpressionTrack.fromPartial(object.typedTrackData.lensExplorer),
            };
        }
        if (object.typedTrackData?.$case === "adToCall" &&
            object.typedTrackData?.adToCall !== undefined &&
            object.typedTrackData?.adToCall !== null) {
            message.typedTrackData = {
                $case: "adToCall",
                adToCall: ad_to_call_impression_track_1.AdToCallImpressionTrack.fromPartial(object.typedTrackData.adToCall),
            };
        }
        if (object.typedTrackData?.$case === "adToMessage" &&
            object.typedTrackData?.adToMessage !== undefined &&
            object.typedTrackData?.adToMessage !== null) {
            message.typedTrackData = {
                $case: "adToMessage",
                adToMessage: ad_to_message_impression_track_1.AdToMessageImpressionTrack.fromPartial(object.typedTrackData.adToMessage),
            };
        }
        if (object.typedTrackData?.$case === "showcase" &&
            object.typedTrackData?.showcase !== undefined &&
            object.typedTrackData?.showcase !== null) {
            message.typedTrackData = {
                $case: "showcase",
                showcase: showcase_impression_track_1.ShowcaseImpressionTrack.fromPartial(object.typedTrackData.showcase),
            };
        }
        if (object.typedTrackData?.$case === "adToPlace" &&
            object.typedTrackData?.adToPlace !== undefined &&
            object.typedTrackData?.adToPlace !== null) {
            message.typedTrackData = {
                $case: "adToPlace",
                adToPlace: ad_to_place_impression_track_1.AdToPlaceImpressionTrack.fromPartial(object.typedTrackData.adToPlace),
            };
        }
        if (object.typedTrackData?.$case === "leadGeneration" &&
            object.typedTrackData?.leadGeneration !== undefined &&
            object.typedTrackData?.leadGeneration !== null) {
            message.typedTrackData = {
                $case: "leadGeneration",
                leadGeneration: lead_generation_impression_track_1.LeadGenerationImpressionTrack.fromPartial(object.typedTrackData.leadGeneration),
            };
        }
        if (object.typedTrackData?.$case === "payToPromote" &&
            object.typedTrackData?.payToPromote !== undefined &&
            object.typedTrackData?.payToPromote !== null) {
            message.typedTrackData = {
                $case: "payToPromote",
                payToPromote: pay_to_promote_impression_track_1.PayToPromoteImpressionTrack.fromPartial(object.typedTrackData.payToPromote),
            };
        }
        if (object.typedTrackData?.$case === "reminder" &&
            object.typedTrackData?.reminder !== undefined &&
            object.typedTrackData?.reminder !== null) {
            message.typedTrackData = {
                $case: "reminder",
                reminder: reminder_impression_track_1.ReminderTrack.fromPartial(object.typedTrackData.reminder),
            };
        }
        if (object.typedTrackData?.$case === "survey" &&
            object.typedTrackData?.survey !== undefined &&
            object.typedTrackData?.survey !== null) {
            message.typedTrackData = {
                $case: "survey",
                survey: survey_impression_track_1.SurveyImpressionTrack.fromPartial(object.typedTrackData.survey),
            };
        }
        message.thirdPartyUrls = object.thirdPartyUrls?.map((e) => e) || [];
        message.viewContext =
            object.viewContext !== undefined && object.viewContext !== null
                ? exports.ViewContext.fromPartial(object.viewContext)
                : undefined;
        message.adFlagData =
            object.adFlagData !== undefined && object.adFlagData !== null
                ? ad_flag_data_1.AdFlagData.fromPartial(object.adFlagData)
                : undefined;
        message.screenWidth = object.screenWidth ?? undefined;
        message.screenHeight = object.screenHeight ?? undefined;
        message.creativeHeight = object.creativeHeight ?? undefined;
        message.creativeWidth = object.creativeWidth ?? undefined;
        message.isUnskippableAd = object.isUnskippableAd ?? undefined;
        message.cognac =
            object.cognac !== undefined && object.cognac !== null
                ? cognac_metadata_1.CognacMetadata.fromPartial(object.cognac)
                : undefined;
        message.thirdPartyImpressionUrls =
            object.thirdPartyImpressionUrls?.map((e) => e) || [];
        message.thirdPartyClickUrls =
            object.thirdPartyClickUrls?.map((e) => e) || [];
        message.additionalFormatType = object.additionalFormatType ?? 0;
        message.skAdNetworkVersion = object.skAdNetworkVersion ?? undefined;
        message.thirdPartyEngagedViewUrls =
            object.thirdPartyEngagedViewUrls?.map((e) => e) || [];
        message.openProfilePage = object.openProfilePage ?? undefined;
        message.adHidingData =
            object.adHidingData !== undefined && object.adHidingData !== null
                ? ad_hiding_data_1.AdHidingData.fromPartial(object.adHidingData)
                : undefined;
        message.skAdNetworkClickThroughVersion =
            object.skAdNetworkClickThroughVersion ?? undefined;
        message.skAdNetworkViewThroughVersion =
            object.skAdNetworkViewThroughVersion ?? undefined;
        return message;
    },
};
function createBaseViewContext() {
    return {
        exitEvent: 0,
        viewSource: 0,
        storiesLeft: undefined,
        renderedPosition: 0,
        intendedPosition: 0,
        adIndexPos: undefined,
        snapIndex: undefined,
        snapCount: undefined,
        editionId: undefined,
        publisherId: undefined,
        posterId: undefined,
        audioPlaybackVolume: undefined,
        autoAdvanceIndex: undefined,
        autoAdvanceCount: undefined,
        isArchivedEdition: undefined,
        useTrackAndGet: undefined,
        attachmentTriggerType: 0,
        operaType: 0,
        isOptionalAdBreak: undefined,
        operaActionBarType: 0,
        placementInPod: undefined,
        adsPerPod: undefined,
        precedingStoryType: 0,
        adInsertionDelayedReason: 0,
        isWithinPayToPromoteContent: undefined,
        profileId: undefined,
        organicAssetId: undefined,
        organicAssetType: 0,
        organicContextAssetId: undefined,
        organicContextAssetType: 0,
        parentAdId: undefined,
        organicContextProfileId: undefined,
        subscriberStatus: undefined,
        gameBuildId: undefined,
        podId: undefined,
        podIndexPos: undefined,
        adsPerPodOriginal: undefined,
        publisherName: undefined,
    };
}
exports.ViewContext = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.exitEvent !== 0) {
            writer.uint32(8).int32(message.exitEvent);
        }
        if (message.viewSource !== 0) {
            writer.uint32(16).int32(message.viewSource);
        }
        if (message.storiesLeft !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.storiesLeft }, writer.uint32(26).fork()).ldelim();
        }
        if (message.renderedPosition !== 0) {
            writer.uint32(32).int32(message.renderedPosition);
        }
        if (message.intendedPosition !== 0) {
            writer.uint32(40).int32(message.intendedPosition);
        }
        if (message.adIndexPos !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.adIndexPos }, writer.uint32(50).fork()).ldelim();
        }
        if (message.snapIndex !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.snapIndex }, writer.uint32(58).fork()).ldelim();
        }
        if (message.snapCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.snapCount }, writer.uint32(66).fork()).ldelim();
        }
        if (message.editionId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.editionId }, writer.uint32(74).fork()).ldelim();
        }
        if (message.publisherId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.publisherId }, writer.uint32(82).fork()).ldelim();
        }
        if (message.posterId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.posterId }, writer.uint32(90).fork()).ldelim();
        }
        if (message.audioPlaybackVolume !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.audioPlaybackVolume }, writer.uint32(98).fork()).ldelim();
        }
        if (message.autoAdvanceIndex !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.autoAdvanceIndex }, writer.uint32(106).fork()).ldelim();
        }
        if (message.autoAdvanceCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.autoAdvanceCount }, writer.uint32(114).fork()).ldelim();
        }
        if (message.isArchivedEdition !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isArchivedEdition }, writer.uint32(122).fork()).ldelim();
        }
        if (message.useTrackAndGet !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.useTrackAndGet }, writer.uint32(130).fork()).ldelim();
        }
        if (message.attachmentTriggerType !== 0) {
            writer.uint32(136).int32(message.attachmentTriggerType);
        }
        if (message.operaType !== 0) {
            writer.uint32(144).int32(message.operaType);
        }
        if (message.isOptionalAdBreak !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isOptionalAdBreak }, writer.uint32(154).fork()).ldelim();
        }
        if (message.operaActionBarType !== 0) {
            writer.uint32(160).int32(message.operaActionBarType);
        }
        if (message.placementInPod !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.placementInPod }, writer.uint32(170).fork()).ldelim();
        }
        if (message.adsPerPod !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.adsPerPod }, writer.uint32(178).fork()).ldelim();
        }
        if (message.precedingStoryType !== 0) {
            writer.uint32(184).int32(message.precedingStoryType);
        }
        if (message.adInsertionDelayedReason !== 0) {
            writer.uint32(192).int32(message.adInsertionDelayedReason);
        }
        if (message.isWithinPayToPromoteContent !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isWithinPayToPromoteContent }, writer.uint32(202).fork()).ldelim();
        }
        if (message.profileId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.profileId }, writer.uint32(210).fork()).ldelim();
        }
        if (message.organicAssetId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.organicAssetId }, writer.uint32(218).fork()).ldelim();
        }
        if (message.organicAssetType !== 0) {
            writer.uint32(224).int32(message.organicAssetType);
        }
        if (message.organicContextAssetId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.organicContextAssetId }, writer.uint32(234).fork()).ldelim();
        }
        if (message.organicContextAssetType !== 0) {
            writer.uint32(240).int32(message.organicContextAssetType);
        }
        if (message.parentAdId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.parentAdId }, writer.uint32(250).fork()).ldelim();
        }
        if (message.organicContextProfileId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.organicContextProfileId }, writer.uint32(258).fork()).ldelim();
        }
        if (message.subscriberStatus !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.subscriberStatus }, writer.uint32(266).fork()).ldelim();
        }
        if (message.gameBuildId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.gameBuildId }, writer.uint32(274).fork()).ldelim();
        }
        if (message.podId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.podId }, writer.uint32(282).fork()).ldelim();
        }
        if (message.podIndexPos !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.podIndexPos }, writer.uint32(290).fork()).ldelim();
        }
        if (message.adsPerPodOriginal !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.adsPerPodOriginal }, writer.uint32(298).fork()).ldelim();
        }
        if (message.publisherName !== undefined) {
            wrappers_1.StringValue.encode({ value: message.publisherName }, writer.uint32(306).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseViewContext();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.exitEvent = reader.int32();
                    break;
                case 2:
                    message.viewSource = reader.int32();
                    break;
                case 3:
                    message.storiesLeft = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.renderedPosition = reader.int32();
                    break;
                case 5:
                    message.intendedPosition = reader.int32();
                    break;
                case 6:
                    message.adIndexPos = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.snapIndex = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.snapCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.editionId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 10:
                    message.publisherId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 11:
                    message.posterId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 12:
                    message.audioPlaybackVolume = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 13:
                    message.autoAdvanceIndex = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 14:
                    message.autoAdvanceCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 15:
                    message.isArchivedEdition = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 16:
                    message.useTrackAndGet = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 17:
                    message.attachmentTriggerType = reader.int32();
                    break;
                case 18:
                    message.operaType = reader.int32();
                    break;
                case 19:
                    message.isOptionalAdBreak = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 20:
                    message.operaActionBarType = reader.int32();
                    break;
                case 21:
                    message.placementInPod = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 22:
                    message.adsPerPod = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 23:
                    message.precedingStoryType = reader.int32();
                    break;
                case 24:
                    message.adInsertionDelayedReason = reader.int32();
                    break;
                case 25:
                    message.isWithinPayToPromoteContent = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 26:
                    message.profileId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 27:
                    message.organicAssetId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 28:
                    message.organicAssetType = reader.int32();
                    break;
                case 29:
                    message.organicContextAssetId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 30:
                    message.organicContextAssetType = reader.int32();
                    break;
                case 31:
                    message.parentAdId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 32:
                    message.organicContextProfileId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 33:
                    message.subscriberStatus = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 34:
                    message.gameBuildId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 35:
                    message.podId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 36:
                    message.podIndexPos = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 37:
                    message.adsPerPodOriginal = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 38:
                    message.publisherName = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseViewContext();
        message.exitEvent = object.exitEvent ?? 0;
        message.viewSource = object.viewSource ?? 0;
        message.storiesLeft = object.storiesLeft ?? undefined;
        message.renderedPosition = object.renderedPosition ?? 0;
        message.intendedPosition = object.intendedPosition ?? 0;
        message.adIndexPos = object.adIndexPos ?? undefined;
        message.snapIndex = object.snapIndex ?? undefined;
        message.snapCount = object.snapCount ?? undefined;
        message.editionId = object.editionId ?? undefined;
        message.publisherId = object.publisherId ?? undefined;
        message.posterId = object.posterId ?? undefined;
        message.audioPlaybackVolume = object.audioPlaybackVolume ?? undefined;
        message.autoAdvanceIndex = object.autoAdvanceIndex ?? undefined;
        message.autoAdvanceCount = object.autoAdvanceCount ?? undefined;
        message.isArchivedEdition = object.isArchivedEdition ?? undefined;
        message.useTrackAndGet = object.useTrackAndGet ?? undefined;
        message.attachmentTriggerType = object.attachmentTriggerType ?? 0;
        message.operaType = object.operaType ?? 0;
        message.isOptionalAdBreak = object.isOptionalAdBreak ?? undefined;
        message.operaActionBarType = object.operaActionBarType ?? 0;
        message.placementInPod = object.placementInPod ?? undefined;
        message.adsPerPod = object.adsPerPod ?? undefined;
        message.precedingStoryType = object.precedingStoryType ?? 0;
        message.adInsertionDelayedReason = object.adInsertionDelayedReason ?? 0;
        message.isWithinPayToPromoteContent =
            object.isWithinPayToPromoteContent ?? undefined;
        message.profileId = object.profileId ?? undefined;
        message.organicAssetId = object.organicAssetId ?? undefined;
        message.organicAssetType = object.organicAssetType ?? 0;
        message.organicContextAssetId = object.organicContextAssetId ?? undefined;
        message.organicContextAssetType = object.organicContextAssetType ?? 0;
        message.parentAdId = object.parentAdId ?? undefined;
        message.organicContextProfileId =
            object.organicContextProfileId ?? undefined;
        message.subscriberStatus = object.subscriberStatus ?? undefined;
        message.gameBuildId = object.gameBuildId ?? undefined;
        message.podId = object.podId ?? undefined;
        message.podIndexPos = object.podIndexPos ?? undefined;
        message.adsPerPodOriginal = object.adsPerPodOriginal ?? undefined;
        message.publisherName = object.publisherName ?? undefined;
        return message;
    },
};
//# sourceMappingURL=impression_data.js.map